/**
 * Retrieve the value of the given variable for the current environment. In remote environments (sandbox, dev, test & prod)
 * the value is passed as variable when starting the Docker image and will be assigned to window.configs
 * In case not window.config variable is found, it will fallback to using variable in process.env
 *
 * @param {string} varName
 * @returns
 */

import { EnvironmentTypes } from '@/types/environmentTypes';

interface WindowConfig extends Window {
  configs?: {
    [key: string]: string;
  };
}

export function isProdEnv(): boolean {
  return getEnv(EnvironmentTypes.VITE_APP_ENV) === 'prod';
}

export function isTestEnv(): boolean {
  return getEnv(EnvironmentTypes.VITE_APP_ENV) === 'test';
}

export function isDevEnv(): boolean {
  return getEnv(EnvironmentTypes.VITE_APP_ENV) === 'dev';
}

export function isSandboxEnv(): boolean {
  return getEnv(EnvironmentTypes.VITE_APP_ENV) === 'sandbox';
}

export function isLocalEnv(): boolean {
  return getEnv(EnvironmentTypes.VITE_APP_ENV) === 'local';
}

export function isEnvDevOrBelow(): boolean {
  return isLocalEnv() || isSandboxEnv() || isDevEnv();
}

export default function getEnv(varName: string): any {
  // return (window as WindowConfig)?.configs?.[varName] || process.env[varName]

  return (window as WindowConfig)?.configs?.[varName] || import.meta.env[varName];
}
